import React, { FC, useState } from 'react';
import { ButtonGroup, Card, CardContent, CardHeader, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useStyles } from './styles';
import { PATH_IB_LINK_STATISTICS, PATH_REGISTRATION_LINKS } from '../../../../utils';
import { ClientLinksIcon, DocumentIcon, PlusIcon } from '../../../../components';
import { PartnershipLinkDialog } from '../../../RegistrationLinks';
import { PartnerPartnership } from '../../../../models';

interface Props {
  links: number;
  translation: any;
  partnerships: PartnerPartnership[];
}

export const Links: FC<Props> = ({ links, partnerships, translation }) => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [dialogTrigger, setDialogTrigger] = useState<boolean>(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Card className={`${classes.root} ${classes.links}`}>
        <CardHeader
          action={
            <>
              <ButtonGroup ref={anchorRef} className={classes.buttonGroup}>
                <IconButton className={classes.button} onClick={handleToggle}>
                  <MoreVert />
                </IconButton>
              </ButtonGroup>
              <Popper open={open} anchorEl={anchorRef.current} transition disablePortal style={{ zIndex: 6000 }}>
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList className={classes.menuList}>
                          <MenuItem className={classes.menuItem} component={Link} to={PATH_REGISTRATION_LINKS} style={{ paddingInlineStart: 0 }}>
                            <ClientLinksIcon />
                            <span className={classes.menuItemText} style={{ marginInlineStart: 0 }}>
                              {translation.manage_links}
                            </span>
                          </MenuItem>
                          <MenuItem
                            className={classes.menuItem}
                            onClick={() => {
                              setOpen(false);
                              setDialogTrigger(true);
                            }}
                          >
                            <PlusIcon />
                            <span className={classes.menuItemText}>{translation.create_link}</span>
                          </MenuItem>
                          <span className={classes.menuTitle}>{translation.text_6663}</span>
                          <MenuItem className={classes.menuItem} component={Link} to={PATH_IB_LINK_STATISTICS}>
                            <DocumentIcon />
                            <span className={classes.menuItemText}>{translation.ibLinkStatistics}</span>
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </>
          }
          title={translation.links}
        />
        <CardContent>
          <Typography component="p" className={classes.content}>
            {links}
          </Typography>
        </CardContent>
      </Card>
      <PartnershipLinkDialog
        partnerships={partnerships}
        handleClose={() => {
          setDialogTrigger(false);
          history.push(PATH_REGISTRATION_LINKS);
        }}
        open={dialogTrigger}
      />
    </>
  );
};
